import { config } from '@/config';

export type PublicSiteVariant = 'current' | 'discoverability';
export type PublicSitePageKey = 'docs' | 'features' | 'pricing';
export type PublicSiteConfig = {
  variant: PublicSiteVariant;
  pages: Record<PublicSitePageKey, boolean>;
};

export const publicSiteConfig: PublicSiteConfig = config.publicSite;

export const isPublicSitePageEnabled = (page: PublicSitePageKey): boolean =>
  publicSiteConfig.pages[page];
